import { create } from "zustand";
import api from "../service/api";
import { toast } from "react-toastify";

interface SettingsState {
  loading: boolean;
  modules: any | null;
  invoiceConfig: any | null;
  paymentConfigs: any[];
  
  // Eylemler (Actions)
  fetchSettings: () => Promise<void>;
  saveEInvoice: (data: any) => Promise<boolean>;
  savePayment: (data: any) => Promise<boolean>;
  deletePayment: (id: number) => Promise<boolean>;
}

export const useSettingsStore = create<SettingsState>((set, get) => ({
  loading: false,
  modules: null,
  invoiceConfig: null,
  paymentConfigs: [],

  // Tüm ayarları tek seferde yükle
  fetchSettings: async () => {
    set({ loading: true });
    try {
      const [modulesRes, payRes, invRes] = await Promise.all([
        api.get("/firm-modules/my-modules"),
        api.get("/firm-integration/payment-configs"),
        api.get("/firm-integration/e-invoice-config")
      ]);

      set({ 
        modules: modulesRes.data, 
        paymentConfigs: payRes.data, 
        invoiceConfig: invRes.data 
      });
    } catch (error) {
      toast.error("Ayarlar yüklenirken bir hata oluştu.");
    } finally {
      set({ loading: false });
    }
  },

  // E-Fatura Ayarlarını Kaydet
  saveEInvoice: async (data) => {
    try {
      const res = await api.post("/firm-integration/save-e-invoice", data);
      set({ invoiceConfig: res.data });
      toast.success("E-Fatura ayarları güncellendi.");
      return true;
    } catch (error) {
      toast.error("E-Fatura kaydedilemedi.");
      return false;
    }
  },

  // Sanal POS Kaydet/Güncelle
  savePayment: async (data) => {
    try {
      await api.post("/firm-integration/save-payment", data);
      // Listeyi güncellemek için tekrar çekiyoruz
      const payRes = await api.get("/firm-integration/payment-configs");
      set({ paymentConfigs: payRes.data });
      toast.success("Ödeme ayarı kaydedildi.");
      return true;
    } catch (error) {
      toast.error("Ödeme ayarı kaydedilemedi.");
      return false;
    }
  },

  // Sanal POS Sil
  deletePayment: async (id) => {
    try {
      await api.delete(`/firm-integration/payment-config/${id}`);
      set((state) => ({
        paymentConfigs: state.paymentConfigs.filter(p => p.id !== id)
      }));
      toast.success("Ödeme kanalı silindi.");
      return true;
    } catch (error) {
      toast.error("Silme işlemi başarısız.");
      return false;
    }
  }
}));